import React, { useState, useRef } from 'react';
import { Image, FolderOpen, Camera } from 'lucide-react';

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

export const UploadChooser = ({ onFile, accept = "image/*,.pdf", disabled, children, testId }) => {
  const [showMenu, setShowMenu] = useState(false);
  const photoRef = useRef(null);
  const cameraRef = useRef(null);
  const fileRef = useRef(null);

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (file) onFile(file);
    setShowMenu(false);
    e.target.value = '';
  };

  return (
    <div className="relative inline-block w-full">
      <div onClick={() => !disabled && setShowMenu(!showMenu)} data-testid={testId}>
        {children}
      </div>

      {showMenu && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setShowMenu(false)} />
          <div className="absolute left-0 right-0 top-full mt-1 z-50 bg-white rounded-lg shadow-lg border border-slate-200 overflow-hidden animate-in fade-in slide-in-from-top-1 duration-150" data-testid="upload-chooser-menu">
            <button
              type="button"
              className="w-full flex items-center gap-3 px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
              onClick={() => { photoRef.current?.click(); }}
              data-testid="upload-choose-photo"
            >
              <Image className="w-4 h-4 text-[#1D35A0]" />
              <span>Choose Photo</span>
            </button>
            {isMobile() && (
              <>
                <div className="border-t border-slate-100" />
                <button
                  type="button"
                  className="w-full flex items-center gap-3 px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
                  onClick={() => { cameraRef.current?.click(); }}
                  data-testid="upload-take-photo"
                >
                  <Camera className="w-4 h-4 text-[#1D35A0]" />
                  <span>Take Photo</span>
                </button>
              </>
            )}
            <div className="border-t border-slate-100" />
            <button
              type="button"
              className="w-full flex items-center gap-3 px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
              onClick={() => { fileRef.current?.click(); }}
              data-testid="upload-choose-file"
            >
              <FolderOpen className="w-4 h-4 text-[#1D35A0]" />
              <span>Choose File</span>
            </button>
          </div>
        </>
      )}

      {/* Choose Photo opens photo gallery (images only) */}
      <input ref={photoRef} type="file" accept="image/*" onChange={handleFile} className="hidden" />
      {/* Take Photo opens camera (mobile only) */}
      <input ref={cameraRef} type="file" accept="image/*" capture="environment" onChange={handleFile} className="hidden" />
      {/* Choose File opens full file browser */}
      <input ref={fileRef} type="file" accept={accept} onChange={handleFile} className="hidden" />
    </div>
  );
};
